// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, Input, OnChanges } from '@angular/core';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { selectShowSection } from '../../store/dashboard-groups.selectors';
import { dashboardGroupsRequested } from '../../store/dashboard-groups.actions';

@Component({
  selector: 'coa-dashboard-groups',
  templateUrl: './dashboard-groups.component.html',
  styleUrls: ['./dashboard-groups.component.scss'],
})
export class DashboardGroupsComponent implements OnChanges {
  @Input() categoryId: string;
  @Input() clientId: string;
  @Input() dateRange: DateRangeFilter;

  showSection$: Observable<boolean> = this.store$.pipe(select(selectShowSection));

  constructor(
    private store$: Store) {
  }

  ngOnChanges(): void {
    if (this.clientId && this.dateRange) {
      this.requestData();
    }
  }

  requestData(): void {
    this.store$.dispatch(dashboardGroupsRequested({
      timePeriod: this.dateRange,
      clientId: this.clientId,
      categoryId: this.categoryId,
    }));
  }
}
